// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 147) return "js/admin/147.js";
	if (chunkId === 356) return "js/admin/356.js";
	if (chunkId === 254) return "js/admin/254.js";
	if (chunkId === 188) return "js/admin/188.js";
	// return url for filenames based on template
	return undefined;
};